
import { IExitModel } from './IProductData';
import { IScript } from './IScript';
import { IPins } from './IPins';
import { enFrequencyType } from 'enums/enFrequencyType';
import { enProductType } from 'enums/enProductType';
import { enPaymentType } from 'enums/enPaymentType';
import { enPaymentMethod } from 'enums/enPaymentMethod';
import { ITickets, IReservationData } from './ITickets';

export interface IProductTemplateMediaConfig {
  readonly background?: IBackgroundTemplateMediaConfig;
  readonly bannerCenter: string;
  readonly bannerTop: string;
  readonly bannerRight: string;
  readonly bannerYoutube: string;
}
export interface IBackgroundTemplateMediaConfig {
  readonly image: string;
  readonly color: number;
}
export interface IProductTemplateConfig {
  readonly id: number;
  readonly media: IProductTemplateMediaConfig;
  readonly styles: any;
  readonly inputStyle: 'normal' | 'material';
}

export enum enCurrency {
  BRL = 'BRL',
  USD = 'USD'
}

export enum enLang {
  EN_US = 'enus',
  PT_BR = 'ptbr'
}

export enum enCountry {
  BR = 'BR',
  US = 'US'
}

export interface IPixel {
  readonly userId?: string;
  readonly campaignKey?: string;
  readonly contentId?: string;
  readonly campaign?: string;
}

export interface IExitModelButton {
  readonly enabled?: boolean;
  readonly theme?: IExitModelButtonTheme;
}

export interface IExitModelButtonTheme {
  readonly text?: string;
  readonly textColor?: string;
  readonly textSize?: number;
  readonly backgroundColor?: string;
  readonly backgroundColorHover?: string;
}

export interface IExitModelTimerTheme {
  readonly title?: string;
  readonly titleColor?: string;
  readonly titleSize?: number;
  readonly backgroundColor?: string;
}

export interface IExitModelMedia {
  readonly video?: string;
  readonly audio?: string;
  readonly image?: string;
}

export interface IExitModelTimer {
  readonly time?: number;
  readonly enabled?: boolean;
  readonly theme?: IExitModelTimerTheme;
}

export interface IExitModel {
  readonly coupon?: string;
  readonly media: IExitModelMedia;
  readonly timer?: IExitModelTimer;
  readonly button?: IExitModelButton;
}

export interface IProductConfig {
  readonly template: IProductTemplateConfig;
  readonly logo: string;
  readonly askAddressBeforePayment: boolean;
  readonly askAddressAfterPayment: boolean;
  readonly enablePaypal: boolean;
  readonly enableBankslip: boolean;
  enableCreditcard: boolean;
  readonly pixel: IPixel;
  readonly hasCoupon: boolean;
  readonly multipleCreditCards: boolean;
  readonly affiliateId?: number;
  readonly producerId?: number;
  readonly maxInstallments?: number;
  readonly exitModal?: IExitModel;
  readonly isOneClick?: boolean;
  readonly askCVV?: boolean;
  readonly scripts: IScript[];
  readonly purchaseLimit: number;
  readonly productType: enProductType;
  readonly hideQuantity: boolean;
  readonly showCardDocument: boolean;
}
export interface IProduct {
  readonly id: number;
  readonly name: string;
  readonly description: string;
  readonly hasValidCoupons: boolean;
  readonly producerName: string;
  readonly producerEmail: string;
}

export interface IInstallment {
  readonly installment: number;
  readonly value: number;
}

export interface ICoupon {
  readonly code: string;
  readonly value: number;
}

export interface ICouponData {
  readonly coupon: ICoupon;
  readonly product: Partial<IProductData>;
}

export interface IShippingData {
  readonly hash: string;
  readonly products: {
    readonly contentId: string;
    readonly quantity: number;
    readonly price: number;
    readonly realPrice: number;
    readonly installments: IInstallment[]
  }[];
  readonly shippingType: number;
  readonly shippingItems: IShipping[];
  readonly reservation: IReservationData;
}

export interface IShipping {
  readonly title: string;
  readonly value: number;
  readonly deadline: number;
  readonly code: string;
  readonly totalValue: number;
  readonly installments: IInstallment[];
}

export interface IUser {
  readonly id?: number;
  readonly street?: string;
  readonly cityId?: number;
  readonly city?: string;
  readonly complement?: string;
  readonly countryId?: number;
  readonly district?: string;
  readonly number?: number;
  readonly province?: string;
  readonly phone?: string;
  readonly document?: string;
  readonly email?: string;
  readonly name?: string;
  readonly personType?: string;
  readonly postalCode?: string;
  readonly creditCard?: ICreditCard;
}

export interface ICreditCard {
  readonly id: number;
  readonly brand: string;
  readonly identifier: string;
  readonly secret: string;
  readonly month: number;
  readonly year: number;
  readonly creationDate: string;
  readonly updatedDate: string;
}

export interface ISubscription {
  readonly frequency?: number;
  readonly frequencyType?: enFrequencyType;
  readonly hasTax?: boolean;
  readonly tax?: number;
  readonly taxTax?: number;
  readonly hasTrial?: boolean;
  readonly trial?: number;
  readonly hasTrialTax?: boolean;
  readonly trialTax?: number;
  readonly price?: number;
  readonly priceTax?: number;
}

export interface IProductData {
  readonly isCached?: boolean;
  readonly hash?: string;
  readonly imageCache?: { [key: number]: string };
  readonly contentId: string;
  readonly transactionKey?: string;
  originalContentId?: string;
  readonly config: IProductConfig;
  readonly products: IProduct[];
  readonly title: string;
  readonly feeInstallment: number;
  readonly installments: IInstallment[];
  readonly installmentSelected?: number;
  readonly numberInstallments: number;
  readonly currency: enCurrency;
  readonly availableCurrencies: enCurrency[];
  readonly price: number;
  readonly tax: number;
  readonly realTax: number;
  readonly taxedPrice: number;
  readonly realPrice: number;
  readonly paymentType: enPaymentType;
  readonly coupon?: ICoupon;
  readonly user?: IUser;
  readonly maxInstallments?: number;
  readonly subscription: ISubscription;
  readonly quantity?: number;
  readonly foreignEnabled: boolean;

  // remover?
  readonly upsell?: enPaymentMethod;
  readonly pins: IPins;
  readonly tickets: ITickets;
  readonly paymentMethod?: string;
}


// WEBPACK FOOTER //
// ./src/interfaces/IProductData.ts